import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSmsConfigurations } from 'services/smsConversations';
import { ISMSConfiguration } from 'services/smsConversations/types';

export const ThunkGetSmsConfigurations = createAsyncThunk<ISMSConfiguration[]>(
  'pod/getSmsConfigurations',
  async () => {
    const r = await getSmsConfigurations();
    return r.data;
  },
);
